<template>
    <div class="box relative">
        <b-button type="is-primary" @click="readAll">Mark all as read</b-button>
        <hr class="toolbar-divider" />
        <div class="noti-container">
            <div class="noti-item" v-for="(item, index) in notifications.data" :key="index" :class="{ new: !item.is_read }">
                <b-icon class="first-icon" pack="fas" :icon="item.icon" custom-size="fa-lg" />
                <div class="text" @click="notificationAction(item)">
                    <h4>{{ item.title }}</h4>
                    <p>{{ item.details }}</p>
                </div>
                <b-tooltip v-if="!item.is_read" label="Mark as read" class="button-center">
                    <div @click="markAsRead(item)" class="pointer">
                        <b-icon icon="bookmark" icon-pack="fas" type="is-dark" />
                    </div>
                </b-tooltip>
            </div>
            <div class="noti-icon"></div>
        </div>
        <b-pagination
            :total="notifications.total"
            v-model="notifications.current_page"
            rounded
            order="is-centered"
            :per-page="notifications.per_page"
            icon-pack="fas"
            @change="loadPage"
        >
        </b-pagination>
        <!-- <div class="has-text-centered" v-if="hasNextPage">
            <b-button>Load more</b-button>
        </div> -->
        <b-loading v-model="isLoading" :is-full-page="false" :can-cancel="true" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            notifications: {},
            isLoading: true,
        };
    },
    created() {
        this.loadPage();
    },
    methods: {
        async loadPage(page = 1) {
            this.isLoading = true;
            try {
                let res = await this.$http.get(`/notifications?page=${page}`);
                this.notifications = res.data;
            } catch (err) {
                this.notify(err, "is-danger");
            }
            this.isLoading = false;
        },
        notificationAction(item) {
            if (!item.is_read) {
                this.markAsRead(item);
            }
            // Go to notification
        },
        markAsRead(item) {
            this.$http.post(`/notifications/${item.id}/read`).catch((err) => {
                this.notify(err, "is-danger");
            });
            item.is_read = true;
        },
        readAll() {
            this.$http
                .post("/notifications/all/read")
                .catch((err) => this.notify(err, "is-danger"))
                .finally(() => this.loadPage(1));
        },
    },
};
</script>

<style>
</style>